import { render, staticRenderFns } from "./Fold.vue?vue&type=template&id=5d596644&scoped=true&"
import script from "./Fold.vue?vue&type=script&lang=js&"
export * from "./Fold.vue?vue&type=script&lang=js&"
import style0 from "./Fold.vue?vue&type=style&index=0&id=5d596644&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d596644",
  null
  
)

export default component.exports